import { useEffect, useState } from "react";

export const useDebounce = (value, delay=300) => {
    const [debouncedValue, setDebouncedValue] = useState(value)

    useEffect(()=> {
        const id = setTimeout(() => {
            setDebouncedValue(value)
        }, delay)

        return () => {
            clearTimeout(id)
        }
    }, [value, delay])
    
    return debouncedValue
}

export function useDebounce1(callback, delay) {
    let timer;
    return function (...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            callback(...args);
        }, delay);
    }
};

;

export const useDebounce2 = (value, delay=300) => {
    
    const [ debouncedValue, setDebouncedValue ] = useState(value)
    const [ isTyping, setIsTyping ] = useState(false)

    useEffect(()=> {

        const id = setTimeout(() => {
            setDebouncedValue(value)
            setIsTyping(true)
        }, delay)
        
        return () => {
            setIsTyping(false)
            clearTimeout(id)
        }
    }, [value, delay])
    
    return { debouncedValue, isTyping }
}
